export RuntimePersistence from "./runtime.persistence";



// WEBPACK FOOTER //
// ./src/core/persistence/index.js